/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TradeRouteImport } from './routes/trade'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TradeAssetRouteImport } from './routes/trade/$asset'

const TradeRoute = TradeRouteImport.update({
  id: '/trade',
  path: '/trade',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TradeAssetRoute = TradeAssetRouteImport.update({
  id: '/$asset',
  path: '/$asset',
  getParentRoute: () => TradeRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/trade': typeof TradeRouteWithChildren
  '/trade/$asset': typeof TradeAssetRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/trade': typeof TradeRouteWithChildren
  '/trade/$asset': typeof TradeAssetRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/trade': typeof TradeRouteWithChildren
  '/trade/$asset': typeof TradeAssetRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/trade' | '/trade/$asset'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/trade' | '/trade/$asset'
  id: '__root__' | '/' | '/trade' | '/trade/$asset'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TradeRoute: typeof TradeRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trade': {
      id: '/trade'
      path: '/trade'
      fullPath: '/trade'
      preLoaderRoute: typeof TradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trade/$asset': {
      id: '/trade/$asset'
      path: '/$asset'
      fullPath: '/trade/$asset'
      preLoaderRoute: typeof TradeAssetRouteImport
      parentRoute: typeof TradeRoute
    }
  }
}

interface TradeRouteChildren {
  TradeAssetRoute: typeof TradeAssetRoute
}

const TradeRouteChildren: TradeRouteChildren = {
  TradeAssetRoute: TradeAssetRoute,
}

const TradeRouteWithChildren = TradeRoute._addFileChildren(TradeRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TradeRoute: TradeRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
